import React, { useState } from "react";
import {
    Layout,
    Menu,
    Button,
    Switch,
    ConfigProvider,
    theme as antdTheme, Card, Space, Row, Col,
} from "antd";
import { BrowserRouter as Router, Route, Link, Routes, useLocation } from "react-router-dom";
import Title from "antd/es/typography/Title";

const { Header, Content, Footer } = Layout;

const routeToUrlMap: { [key: string]: string } = {
    "/sportdings": "https://sportdings.dowtex.com",
    "/saufdings": "https://saufdings.dowtex.com",
    "/saufdingsLegacy": "https://saufdingsLegacy.dowtex.com",
    "/sportdingsLegacy": "https://sportdingsLegacy.dowtex.com",
};

const AppHeader: React.FC<{ theme: string; toggleTheme: () => void }> = ({ theme, toggleTheme }) => {
    const location = useLocation(); // Now this is valid since we are inside a <Router> context
    const externalUrl = routeToUrlMap[location.pathname] || null;

    return (
        <Header style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ display: "flex", alignItems: "left" }}>
                <div className="logo" style={{ marginRight: 20 }} />
                {/* Navigation Menu */}
                <Menu theme={"dark"} mode="horizontal">
                    <Menu.Item key="1">
                        <Link to="/home">Home</Link>
                    </Menu.Item>
                    <Menu.Item key="2">
                        <Link to="/sportdings">Sportdings</Link>
                    </Menu.Item>
                    <Menu.Item key="3">
                        <Link to="/saufdings">Saufdings</Link>
                    </Menu.Item>
                    <Menu.Item key="4">
                        <Link to="/saufdingsLegacy">Saufdings Legacy</Link>
                    </Menu.Item>
                    <Menu.Item key="5">
                        <Link to="/sportdingsLegacy">Sportdings Legacy</Link>
                    </Menu.Item>
                </Menu>
            </div>

            {/* "Go to Website" Button */}
            {externalUrl && (
                <Button type="primary" style={{ marginRight: 20 }} onClick={() => window.open(externalUrl, "_blank")}>
                    Go to Website
                </Button>
            )}

            {/* Dark Mode Switch
            <Switch
                checked={theme === "dark"}
                onChange={toggleTheme}
                checkedChildren="🌙"
                unCheckedChildren="🌞"
            /> */}
        </Header>
    );
};

const App: React.FC = () => {
    const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark");
    const { darkAlgorithm, defaultAlgorithm } = antdTheme;

    const toggleTheme = () => {
        const newTheme = theme === "light" ? "dark" : "light";
        setTheme(newTheme);
        localStorage.setItem("theme", newTheme);
    };

    return (
        <ConfigProvider
            theme={{
                algorithm: theme === "dark" ? darkAlgorithm : defaultAlgorithm,
            }}
        >
            <Router>
                <Layout style={{ minHeight: "100vh" }}>
                    <AppHeader theme={theme} toggleTheme={toggleTheme} />

                    <Content style={{ flex: 1, padding: "24px 50px" }}>
                        <Routes>
                            <Route
                                path="/*"
                                element={
                                    <div style={{ display: "flex", flexDirection: "column", minHeight: "100%" }}>
                                        <Card
                                            bodyStyle={{ padding: 40 }}
                                            style={{ flex: 1 }}
                                            title={
                                                <Title level={1} style={{ textAlign: "center", marginBottom: 40 }}>
                                                    Welcome to Dowtex
                                                </Title>
                                            }
                                        >
                                            <Space direction="vertical" style={{ width: "100%" }} size="large">
                                                <Row gutter={[24, 24]} justify="center">
                                                    {[
                                                        {
                                                            title: "Sportdings",
                                                            description: "Track your sports activities and performance. And how about you stop being a pussy ass bitch?",
                                                            href: "https://sportdings.dowtex.com",
                                                        },
                                                        {
                                                            title: "Saufdings",
                                                            description: "Fun and games for your party nights. Maybe even more, but tbd lol",
                                                            href: "https://saufdings.dowtex.com",
                                                        },
                                                        {
                                                            title: "Sportdings Legacy",
                                                            description: "Old version of Sportdings, still alive. But not as good as the new one.",
                                                            href: "https://sportdingsLegacy.dowtex.com",
                                                        },
                                                        {
                                                            title: "Saufdings Legacy",
                                                            description: "Previous version of Saufdings. Maybe the new one does contain some errors or shit, I dunno.",
                                                            href: "https://saufdingsLegacy.dowtex.com",
                                                        },
                                                    ].map((app) => (
                                                        <Col xs={24} sm={12} md={10} lg={8} xl={6} key={app.title}>
                                                            <a
                                                                href={app.href}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{ textDecoration: "none" }}
                                                            >
                                                                <Card
                                                                    hoverable
                                                                    style={{ height: "100%", borderRadius: 8 }}
                                                                    title={app.title}
                                                                    bodyStyle={{ minHeight: 100 }}
                                                                >
                                                                    <p>{app.description}</p>
                                                                </Card>
                                                            </a>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </Space>
                                        </Card>
                                    </div>
                                }
                            />
                            <Route
                                path="/sportdings"
                                element={
                                    <div style={{ width: "100%", height: "93vh" }}>
                                        <iframe
                                            src="https://sportdings.dowtex.com"
                                            style={{ width: "100%", height: "100%", border: "none" }}
                                            title="Sportdings"
                                        />
                                    </div>
                                }
                            />
                            <Route
                                path="/saufdings"
                                element={
                                    <div style={{ width: "100%", height: "93vh" }}>
                                        <iframe
                                            src="https://saufdings.dowtex.com"
                                            style={{ width: "100%", height: "100%", border: "none" }}
                                            title="Saufdings"
                                        />
                                    </div>
                                }
                            />
                            <Route
                                path="/saufdingsLegacy"
                                element={
                                    <div style={{ width: "100%", height: "93vh" }}>
                                        <iframe
                                            src="https://saufdingsLegacy.dowtex.com"
                                            style={{ width: "100%", height: "100%", border: "none" }}
                                            title="Saufdings Legacy"
                                        />
                                    </div>
                                }
                            />
                            <Route
                                path="/sportdingsLegacy"
                                element={
                                    <div style={{ width: "100%", height: "93vh" }}>
                                        <iframe
                                            src="https://sportdingsLegacy.dowtex.com"
                                            style={{ width: "100%", height: "100%", border: "none" }}
                                            title="Sportdings Legacy"
                                        />
                                    </div>
                                }
                            />
                        </Routes>
                    </Content>
                    <Footer style={{ textAlign: "center" }}>Dowtex ©2025</Footer>
                </Layout>
            </Router>

        </ConfigProvider>
    );
};

export default App;